export const ProfitAndLossReport = {
  en: {
    Article: 'Article',
    Total: 'Total',
    Revenue: 'Revenue',
    'Profit & Loss': 'Profit & Loss',
    Income: 'Income',
    Expenses: 'Expenses',
    Profit: 'Profit',
    Loss: 'Loss',
    'Net revenue': 'Net revenue',
    Discounts: 'Discounts',
    'Gross revenue': 'Gross revenue',
    'Cost of goods sold': 'Cost of goods sold',
    'Operating expenses': 'Operating expenses',
    'Total expenses': 'Total expenses',
    'Discounts by source': 'Discounts by source',
    'Cards / memberships': 'Cards / memberships',
    'Personal training': 'Personal training',
    'Group classes': 'Group classes',
    Events: 'Events',
    Services: 'Services',
    'Certificates (breakage)': 'Certificates (breakage)',
    Goods: 'Goods',
    Payroll: 'Payroll',
    'Manual discount': 'Manual discount',
    'Card discount': 'Card discount',
    Promotion: 'Promotion',
    'Without a source': 'Without a source',
    'Discounts are informational':
      'Informational only: revenue is already net of discounts, so they are never subtracted again',
    'Gross revenue is net revenue plus discounts':
      'Gross revenue = net revenue + discounts — what would have been earned without them',
    'COGS stays zero until inventory records a cost':
      'The stock cost of the goods sold — zero until inventory records a cost per sale',
    From: 'From (inclusive)',
    Till: 'Till (inclusive)',
    Day: 'Day',
    Month: 'Month',
    Year: 'Year',
    'Custom period': 'Custom period',
    Location: 'Location',
    'Business direction': 'Business direction',
    'No direction': 'No direction',
    Breakdown: 'Breakdown',
    'No breakdown': 'No breakdown',
    'By location': 'By location',
    'By business direction': 'By business direction',
    'Clear filter': 'Clear filter',
    'Failed to load the report': 'Failed to load the report',
    'Something went wrong while fetching the data':
      'Something went wrong while fetching the data',
    'Try again': 'Try again',
  },
  uk: {
    Article: 'Стаття',
    Total: 'Сума',
    Revenue: 'Дохід',
    'Profit & Loss': 'Прибутки та збитки',
    Income: 'Доходи',
    Expenses: 'Витрати',
    Profit: 'Прибуток',
    Loss: 'Збиток',
    'Net revenue': 'Чистий дохід',
    Discounts: 'Знижки',
    'Gross revenue': 'Валовий дохід',
    'Cost of goods sold': 'Собівартість проданих товарів',
    'Operating expenses': 'Операційні витрати',
    'Total expenses': 'Разом витрати',
    'Discounts by source': 'Знижки за джерелом',
    'Cards / memberships': 'Картки / абонементи',
    'Personal training': 'Персональні тренування',
    'Group classes': 'Групові заняття',
    Events: 'Події',
    Services: 'Сервіси',
    'Certificates (breakage)': 'Сертифікати (згорілі)',
    Goods: 'Товари',
    Payroll: 'Зарплата',
    'Manual discount': 'Ручна знижка',
    'Card discount': 'Знижка за карткою',
    Promotion: 'Акція',
    'Without a source': 'Без джерела',
    'Discounts are informational':
      'Лише інформативно: дохід уже враховує знижки, тому вони не віднімаються вдруге',
    'Gross revenue is net revenue plus discounts':
      'Валовий дохід = чистий дохід + знижки — скільки було б зароблено без них',
    'COGS stays zero until inventory records a cost':
      'Закупівельна вартість проданих товарів — нуль, доки склад не фіксує собівартість продажу',
    From: 'З (включно)',
    Till: 'До (включно)',
    Day: 'День',
    Month: 'Місяць',
    Year: 'Рік',
    'Custom period': 'Інший період',
    Location: 'Локація',
    'Business direction': 'Напрямок діяльності',
    'No direction': 'Без напрямку',
    Breakdown: 'Розріз',
    'No breakdown': 'Без розрізу',
    'By location': 'За локаціями',
    'By business direction': 'За напрямками діяльності',
    'Clear filter': 'Очистити фільтр',
    'Failed to load the report': 'Не вдалося завантажити звіт',
    'Something went wrong while fetching the data':
      'Щось пішло не так під час завантаження даних',
    'Try again': 'Спробувати ще раз',
  },
};
